import { Link, useLocation } from 'react-router-dom';
import { useState, useEffect, useCallback } from 'react';
import { categories } from '@/mocks/categories';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const location = useLocation();

  const handleScroll = useCallback(() => {
    setScrolled(window.scrollY > 20);
  }, []);

  useEffect(() => {
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [handleScroll]);

  useEffect(() => {
    setMobileOpen(false);
    setSearchOpen(false);
  }, [location]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link
            to="/"
            className="flex items-center gap-2 group"
          >
            <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500 text-background-50 font-heading font-bold text-lg">
              漫
            </span>
            <span className="font-heading font-bold text-xl text-foreground-900 whitespace-nowrap">
              韩漫屋
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            {categories.slice(0, 6).map((cat) => (
              <Link
                key={cat.id}
                to={cat.id === 'all' ? '/category/all' : `/category/${cat.slug}`}
                className={`px-3 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap ${
                  location.pathname.includes(`/category/${cat.slug}`) || (cat.id === 'all' && location.pathname === '/category/all')
                    ? 'bg-primary-100 text-primary-700'
                    : 'text-foreground-600 hover:text-foreground-900 hover:bg-background-200'
                }`}
              >
                {cat.name}
              </Link>
            ))}
          </div>

          <div className="hidden md:flex items-center gap-2">
            <div className="relative">
              <button
                onClick={() => setSearchOpen(!searchOpen)}
                className="w-9 h-9 flex items-center justify-center rounded-lg text-foreground-600 hover:text-foreground-900 hover:bg-background-200 transition-colors cursor-pointer"
                aria-label="搜索"
              >
                <i className="ri-search-line text-lg"></i>
              </button>
              {searchOpen && (
                <div className="absolute right-0 top-full mt-1 w-64 bg-background-50 rounded-lg border border-background-200 shadow-lg p-2">
                  <div className="flex items-center gap-2 bg-background-100 rounded-md px-3 py-2">
                    <i className="ri-search-line text-foreground-500 text-sm"></i>
                    <input
                      type="text"
                      value={searchQuery}
                      onChange={(e) => setSearchQuery(e.target.value)}
                      placeholder="搜索漫画..."
                      className="bg-transparent border-none outline-none text-sm text-foreground-900 placeholder-foreground-500 w-full"
                    />
                  </div>
                </div>
              )}
            </div>
            <Link
              to="/about"
              className="px-4 py-2 rounded-lg text-sm font-medium text-foreground-600 hover:text-foreground-900 hover:bg-background-200 transition-colors whitespace-nowrap"
            >
              关于我们
            </Link>
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className="md:hidden w-9 h-9 flex items-center justify-center rounded-lg text-foreground-700 hover:bg-background-200 transition-colors cursor-pointer"
            aria-label="菜单"
          >
            <i className={`ri-${mobileOpen ? 'close' : 'menu'}-line text-xl`}></i>
          </button>
        </div>

        {mobileOpen && (
          <div className="md:hidden border-t border-background-200 bg-background-50">
            <div className="px-4 py-3">
              <div className="flex items-center gap-2 bg-background-100 rounded-lg px-3 py-2 mb-3">
                <i className="ri-search-line text-foreground-500 text-sm"></i>
                <input
                  type="text"
                  placeholder="搜索漫画..."
                  className="bg-transparent border-none outline-none text-sm text-foreground-900 placeholder-foreground-500 w-full"
                />
              </div>
              <div className="grid grid-cols-3 gap-2">
                {categories.map((cat) => (
                  <Link
                    key={cat.id}
                    to={cat.id === 'all' ? '/category/all' : `/category/${cat.slug}`}
                    className="px-3 py-2 rounded-lg text-sm text-center font-medium text-foreground-600 hover:text-foreground-900 hover:bg-background-200 transition-colors"
                  >
                    {cat.name}
                  </Link>
                ))}
              </div>
              <Link
                to="/about"
                className="block w-full mt-2 px-4 py-2.5 rounded-lg text-sm text-center font-medium bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors"
              >
                关于我们
              </Link>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}